import React, { FunctionComponent } from 'react';
import { Dialog, Table } from '../../../../tailwindcomponents';
import { LinePackageOverviewObj } from '../../../../types/line';

type DateConflictDialogProps = {
  visible: boolean;
  reports: Array<LinePackageOverviewObj>;
  headers: Array<string>;
  generateTableBody: (row: LinePackageOverviewObj, index: number, rowsInView: Array<LinePackageOverviewObj>) => React.ReactElement;
  onClose: () => void;
};

const DateConflictDialog: FunctionComponent<DateConflictDialogProps> = ({
  visible,
  reports,
  headers,
  generateTableBody,
  onClose,
}) => {
  const conflictReports = reports.filter(s => s.start_date_bigger_than_due_date);

  return (
    <Dialog
      visible={visible}
      max_width={"xl"}
      title={`Start date later than due date (${conflictReports.length})`}
      context={
        <div>
          <Table
            headers={headers}
            rows={conflictReports}
            generateBody={(row: LinePackageOverviewObj, index: number) => generateTableBody(row, index - 1, conflictReports)}
            pagination={false}
            skipIndexCol={true}
          />
        </div>
      }
      onClose={() => onClose()}
      strict={false}
      show_options={false}
    />
  );
};

export default DateConflictDialog;
